import { useEffect, useState } from "react";
import Logo from "./Logo";
import CtaButton from "./CtaButton";

const Navbar = () => {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 24);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            className={`fixed inset-x-0 top-0 z-50 transition-colors duration-500 ${
                scrolled ? "glass" : "bg-transparent"
            }`}
        >
            <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 md:h-20 lg:px-8">
                <div data-testid="navbar-logo">
                    <div className="hidden sm:block">
                        <Logo size={scrolled ? 32 : 38} />
                    </div>
                    <div className="sm:hidden">
                        <Logo size={28} />
                    </div>
                </div>
                <div className="flex items-center gap-5">
                    <p className="hidden font-mono text-[11px] uppercase tracking-[0.2em] text-white/50 lg:block">
                        Setiap Isnin &amp; Selasa — 8:30 PM
                    </p>
                    <CtaButton
                        location="Navbar"
                        testId="navbar-cta-button"
                        small
                    >
                        PM Admin to Join
                    </CtaButton>
                </div>
            </div>
        </header>
    );
};

export default Navbar;
